'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('HomePageRibbonController', function(PublicAlertsStore, $scope, $translate, $rootScope) {
  var self = this;
  var userLang;
  this.alerts = PublicAlertsStore.getAlerts().filter(filterRibbon);
  showRibbon();

  var ribbonText;
  if (this.alerts.length > 0) {
    setRibbonText(self.alerts[0]);
  }

  PublicAlertsStore.onUpdate('HeaderCtrl', function() {
    self.alerts = PublicAlertsStore.getAlerts().filter(filterRibbon);
    showRibbon();
    if (self.alerts.length > 0) {
      setRibbonText(self.alerts[0]);
    }
  });

  function filterRibbon(alert) {
    return alert.ribbonKey === 'ribbon';
  }

  $rootScope.$on('languageSwitched', function() {
    languageSwitch();
  });

  function setRibbonText(alert) {
    userLang = $translate.use();
    if (userLang === 'en') {
      ribbonText = alert.english.toString();
      updateRibbonText();
    } else {
      ribbonText = alert.french.toString();
      updateRibbonText();
    }
  }

  function showRibbon() {
    var blueRibbon = document.getElementById('ribbonContainer');
    if (blueRibbon !== null) {
      if (self.alerts.length > 0) {
        blueRibbon.style.display = 'block';
      } else {
        blueRibbon.style.display = 'none';
      }
    }
  }

  function updateRibbonText() {
    var standardRibbon = document.getElementById('standardRibbon');
    if (standardRibbon !== null) {
      standardRibbon.innerHTML = ribbonText;
    }
  }

  function languageSwitch() {
    if (self.alerts.length > 0) {
      setRibbonText(self.alerts[0]);
    }
  }

  $scope.$on('$destroy', function() {
    PublicAlertsStore.deregister('PublicAlertsController');
  });
});

